import { render, staticRenderFns } from "./MultiSelectSpecialties.vue?vue&type=template&id=719f52d6&scoped=true"
import script from "./MultiSelectSpecialties.vue?vue&type=script&lang=js"
export * from "./MultiSelectSpecialties.vue?vue&type=script&lang=js"
import style0 from "./MultiSelectSpecialties.vue?vue&type=style&index=0&id=719f52d6&prod&lang=scss&scoped=true"
import style1 from "./MultiSelectSpecialties.vue?vue&type=style&index=1&id=719f52d6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "719f52d6",
  null
  
)

export default component.exports